import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter, Link } from "react-router-dom";
import {aclUtil} from "../../util";
import { createBrowserHistory } from 'history';
import { Breadcrumb as BreadcrumbComponent } from "../../../components";
import { bindActionCreators, compose } from "redux";
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  Alert,
  Checkbox,
  InputGroup,
  Table,
  Radio
} from "react-bootstrap";
import {getAllCategory} from "../../../redux/actions/dealActions";
import { CustomPageCreate }    from '../../../redux/actions/designCenterActions';
import CKEditor from "react-ckeditor-component";
import isEmpty from "lodash.isempty";
import FormValidator from "../../../_helpers/FormValidator";
const history = createBrowserHistory();

class CustomPageAdd extends React.Component {
  static contextTypes = {
    router: PropTypes.object
  }
  constructor(props) {
    super(props); 
    
    this.validator = new FormValidator([
      {
        field: "pagename",
        method: "isEmpty",
        validWhen: false,
        message: "Field is required."
      },
      {
        field: "url",
        method: "isEmpty",
        validWhen: false,
        message: "Field is required."
      },
      {
        field: "content",
        method: "isEmpty",
        validWhen: false,
        message: "Field is required."
      },
      {
        field: "description",
        method: "isEmpty",
        validWhen: false,
        message: "Field is required."
      },
    ]);

    this.state = {
      menuKey: 'ADD_CUSTOMPAGE',
      path: ['Home', 'Custom Page', 'Add New'], 
      links:['home','custompage/list','custompage/add'], 
      loading : false,
      catList: [], 
      pagename:'',
      content:'',
      french_content:'',
      description:'',
      header:1,
      menu:1,
      footer:1,
      homepage:1,
      url:'',
      siteDomain:location.protocol + '//' + location.host,
      catID:[],
      validation: this.validator.valid(), 
      multi_lang:'no',
      asset_lang:'en',
      activeKey:1,
      topads:false,
      tpath:'',
      twidth:'',
      theight:'',
      tid:'',
      tscripttype:'google',
      bottomads:false,
      bpath:'',
      bwidth:'',
      bheight:'',
      bid:'',
      bscripttype:'google',
    }; 
    this.submitted = false;
    this.handleCategory = this.handleCategory.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  handleCategory(e) { 
    const catID = this.state.catID ? this.state.catID : [];

    let index;
    let dealCategory;

    if (e.target.checked) {
      this.setState({ categoryError: "" });
      catID.push(e.target.value);
    } else { 
      index = catID.indexOf(e.target.value);
      catID.splice(index, 1);
    }

    this.setState({ catID: catID });
  }

  handleSubmit = event => {
    event.preventDefault();
    const validation = this.validator.validate(this.state); 
    this.setState({ validation });
    this.submitted = true;

    if (validation.isValid) {
      this.setState({
        loading: true
      });
      let fromdata = {
        pagename:this.state.pagename,
        content:this.state.content,
        french_content:this.state.french_content,
        description:this.state.description,
        header:this.state.header,
        menu:this.state.menu,
        footer:this.state.footer,
        homepage:this.state.homepage,
        catID:this.state.catID,
        url:this.state.url,
        topads:this.state.topads,
        topadsdata:[this.state.tpath, this.state.twidth, this.state.theight, this.state.tid, this.state.tscripttype],
        bottomads:this.state.bottomads,
        bottomadsdata:[this.state.bpath, this.state.bwidth, this.state.bheight, this.state.bid, this.state.bscripttype],
      } 
      this.props.CustomPageCreate(fromdata);
    } else {
      this.setState({
        loading: false
      });
    }
  }

  handleChange = event => {
    this.setState({
      [event.target.name]: event.target.value
    });
  };

  handleChecked = event => { 
    this.setState({
      [event.target.name]: event.target.checked
    });
  };

  handlePageChange = page => { 
    this.props.getAllCategory({ page: 0 }); 
  };

  componentDidMount() {
    this.handlePageChange();
    let siteDDBStatus = JSON.parse(localStorage.getItem('siteDDBStatus'));  
    if(siteDDBStatus){ 
      if(siteDDBStatus.multi_lang=="yes")
      {
        this.setState({ 
          multi_lang: siteDDBStatus.multi_lang, 
          asset_lang: siteDDBStatus.default_lang,
        }); 
      } 
    }
    let siteDomain = (siteDDBStatus.siteDomain ? siteDDBStatus.siteDomain : ''); 
    this.setState({siteDomain: location.protocol + '//' + location.host});
  }

  componentWillReceiveProps(nextProps) {
    if(!aclUtil.isPrimaryMenuAccessible(this.state.menuKey)){
      this.context.router.history.push("/restrictedAccess");
    }
    if (this.props.catList !== nextProps.catList && !isEmpty(nextProps.catList)) {
      if (nextProps.catList) {
        this.setState({ catList: nextProps.catList.data });
      }
    } 

    if (this.props.customdata !== nextProps.customdata && !isEmpty(nextProps.customdata)) {
      this.setState({
        loading: false
      }); 
      if (nextProps.customdata) {
        this.setState({
          msgType: nextProps.customdata.response,
          message: nextProps.customdata.message,
          loading:false
        }); 
        window.scrollTo(0, 0);
        if(nextProps.customdata.response=='success') {
          setTimeout(this.context.router.history.push('/asset/custompage/list'), 3000);
        } 
      }
    }

    if (this.props.error !== nextProps.error) {
      if (nextProps.error) {
        this.setState({
          msgType: "error",
          message: nextProps.error,
          loading: false
        });
        window.scrollTo(0, 0);
      }
    }
    
  }

  handleChangeContent = (evt) => {
    var newContent = evt.editor.getData();
    this.setState({
      content: newContent
    });
  }

  handleChangeContentFrench = (evt) => {
    var newContent = evt.editor.getData();
    this.setState({
      french_content: newContent
    });
  }

  editSource = (mode) => {
    const editor = mode.editor;

    if (editor.mode === 'source') {
        const editable = editor._.editable;
        editable.attachListener(editable, 'input', e => {
            this.handleChangeContent(mode)
        });
    }
  }

  editSourceFrench = (mode) => {
    const editor = mode.editor;

    if (editor.mode === 'source') {
        const editable = editor._.editable;
        editable.attachListener(editable, 'input', e => {
            this.handleChangeContentFrench(mode)
        });
    }
  }

  render() { 
    let catCol;
    let x=1;
    let validation = this.submitted // if the form has been submitted at least once
      ? this.validator.validate(this.state) // then check validity every time we render
      : this.state.validation; // otherwise just use what's in state
    if (this.state.catList.length > 0) { 
      catCol = this.state.catList.map((catObject, index) => {
        return (
          <Col md={2} xs={4} key={catObject.catID}>

            <FormGroup controlId={catObject.catName}>
              <Checkbox
                name="category[]"
                inline
                key={index}
                value={catObject.catID} 
                onChange={this.handleCategory}
              >
                {catObject.catName}
              </Checkbox>
            </FormGroup>
          </Col>
        );
      });
    }

  	return (
      <div className="col-lg-12 update-email-tempelate">
        {this.state.loading === true ? (
          <div className="loader">
            <p className="loading-message">
              <i>Loading...</i>
            </p>
            <div className="spinner">
              <div className="dot1" />
              <div className="dot2" />
            </div>
          </div>
        ) : (
          ""
        )}
        
        <div>
          <div className="row">
            {this.state.show &&
              this.state.alertMessage !== "" &&
              this.state.msgType && (
                <div className="col-lg-12 col-xs-12 col-md-12 col-sm-12">
                  <Alert
                    bsStyle={this.state.msgType}
                    onDismiss={this.handleDismiss}
                  >
                    <strong>{this.state.msgType}:</strong>{" "}
                    {this.state.alertMessage}
                  </Alert>
                </div>
              )}
            <div className="col-lg-12 col-xs-12 col-md-12 col-sm-12">
              <BreadcrumbComponent path={this.state.path} />
            </div>
          </div>
          <div className="panel">
            <header className="panel-heading">Add New Custom Page</header>
            <div className="panel-body">
              <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <Row>
                  <form onSubmit={this.handleSubmit}>
                    <Row>
                      <Col md={10} xs={10} mdOffset={2}>
                        <FormGroup controlId="formpagename"> 
                          <ControlLabel>Custom Page Name</ControlLabel>
                          <FormControl 
                            type="text"
                            value={this.state.pagename}
                            name="pagename"
                            placeholder="Custom Page Name"
                            onChange={this.handleChange}
                            style={{ borderColor: validation.pagename.isInvalid ? 'red' : '' }}
                          />
                        </FormGroup> 
                        <FormGroup controlId="formurl"> 
                          <ControlLabel>Custom Page URL (not include space or symbol)</ControlLabel>
                          <InputGroup>
                            <InputGroup.Addon>{this.state.siteDomain}/page/</InputGroup.Addon>
                            <FormControl 
                              type="text"
                              value={this.state.url}
                              name="url"
                              placeholder="Custom Page URL"
                              onChange={this.handleChange}
                              style={{ borderColor: validation.url.isInvalid ? 'red' : '' }}
                            />
                          </InputGroup> 
                        </FormGroup> 
                        <Col md={12} xs={12}>
                          {catCol && 
                            <Row> 
                              <ControlLabel>Categories (To show deals) </ControlLabel>
                              <Col>
                                {catCol}
                              </Col>
                            </Row>
                          }
                        </Col>

                        <FormGroup controlId="content">
                          <ControlLabel>
                            <span style={{ color: "red" }}>*</span>Content<span>
                              {" "}
                              (Don't change text which has $ symbol)
                            </span>
                          </ControlLabel>
                        </FormGroup>
                        <CKEditor
                          activeClass="p10"
                          content={this.state.content}
                          events={{
                            change: this.handleChangeContent,
                            blur: this.handleChangeContent,
                            afterPaste: this.handleChangeContent,
                            mode: this.editSource
                          }}
                          config={{allowedContent: true}} 
                        />
                        <span style={{ color: "red" }}> {validation.content.message} </span>
                        {(this.state.multi_lang == "yes") &&
                          <FormGroup controlId="frcontent">
                            <ControlLabel>
                              <span style={{ color: "red" }}>*</span>Content (Canadian French)<span>
                                {" "}
                                (Don't change text which has $ symbol)
                              </span>
                            </ControlLabel>
                          </FormGroup>
                        }
                        {(this.state.multi_lang == "yes") &&
                          <CKEditor
                            activeClass="p10"
                            content={this.state.french_content}
                            events={{
                              change: this.handleChangeContentFrench,
                              blur: this.handleChangeContentFrench,
                              afterPaste: this.handleChangeContentFrench,
                              mode: this.editSourceFrench
                            }}
                            config={{allowedContent: true}}
                          />
                        }

                        <Row>
                          <Col md={12} xs={12}>
                            <Checkbox
                              name="topads"
                              inline
                              key={Math.random()}
                              value={this.state.topads} 
                              checked={this.state.topads} 
                              onChange={this.handleChecked}
                            >
                              Enable ads script at Top.
                            </Checkbox>
                          </Col>
                        </Row>
                        {this.state.topads==1 && 
                          (
                          <React.Fragment>
                            <Row>
                              <Col md={12} xs={12}>
                                <Radio 
                                  id={Math.random()} 
                                  name="tscripttype" 
                                  inline 
                                  value="google" 
                                  checked={this.state.tscripttype=='google' ? true : false}
                                  onChange={this.handleChange}
                                > 
                                  Google Script
                                </Radio>
                                <Radio 
                                  id={Math.random()} 
                                  name="tscripttype" 
                                  inline 
                                  value="other"
                                  checked={this.state.tscripttype=='other' ? true : false}
                                  onChange={this.handleChange} 
                                >
                                  Other Script
                                </Radio>
                              </Col>
                            </Row>
                            <Row>
                              <Col md={3} xs={3}>
                                <FormGroup>
                                  <ControlLabel>
                                    Script Path
                                  </ControlLabel>
                                  <FormControl
                                    type="text"
                                    value={this.state.tpath}
                                    placeholder="Script Path"
                                    onChange={this.handleChange}
                                    name="tpath"
                                  />
                                </FormGroup>
                              </Col>
                              <Col md={3} xs={3}>
                                <FormGroup>
                                  <ControlLabel>
                                    Script Id
                                  </ControlLabel>
                                  <FormControl
                                    type="text"
                                    value={this.state.tid}
                                    placeholder="Script Id"
                                    onChange={this.handleChange}
                                    name="tid"
                                  />
                                </FormGroup>
                              </Col>
                              <Col md={3} xs={3}>
                                <FormGroup>
                                  <ControlLabel>
                                    Script Width
                                  </ControlLabel>
                                  <FormControl
                                    type="text"
                                    value={this.state.twidth}
                                    placeholder="Script Width"
                                    onChange={this.handleChange}
                                    name="twidth"
                                  />
                                </FormGroup>
                              </Col>
                              <Col md={3} xs={3}>
                                <FormGroup>
                                  <ControlLabel>
                                    Script Height
                                  </ControlLabel>
                                  <FormControl
                                    type="text"
                                    value={this.state.theight}
                                    placeholder="Script Height"
                                    onChange={this.handleChange}
                                    name="theight"
                                  />
                                </FormGroup>
                              </Col>
                            </Row>
                          </React.Fragment>
                          )
                        }
                        <Row>
                          <Col md={12} xs={12}>
                            <Checkbox
                              name="bottomads"
                              inline
                              key={Math.random()}
                              value={this.state.bottomads} 
                              checked={this.state.bottomads} 
                              onChange={this.handleChecked}
                            >
                              Enable ads script at Bottom.
                            </Checkbox>
                          </Col>
                        </Row>
                        {this.state.bottomads==1 && 
                          (
                          <React.Fragment>
                            <Row>
                              <Col md={12} xs={12}>
                                <Radio 
                                  id={Math.random()} 
                                  name="bscripttype" 
                                  inline 
                                  value="google"
                                  checked={this.state.bscripttype=='google' ? true : false}
                                  onChange={this.handleChange}
                                > 
                                  Google Script 
                                </Radio>
                                <Radio 
                                  id={Math.random()} 
                                  name="bscripttype" 
                                  inline 
                                  value="other"
                                  checked={this.state.bscripttype=='other' ? true : false}
                                  onChange={this.handleChange}
                                > 
                                  Other Script
                                </Radio>
                              </Col>
                            </Row>
                            <Row>
                              <Col md={3} xs={3}>
                                <FormGroup>
                                  <ControlLabel>
                                    Script Path
                                  </ControlLabel>
                                  <FormControl
                                    type="text"
                                    value={this.state.bpath}
                                    placeholder="Script Path"
                                    onChange={this.handleChange}
                                    name="bpath"
                                  />
                                </FormGroup>
                              </Col>
                              <Col md={3} xs={3}>
                                <FormGroup>
                                  <ControlLabel>
                                    Script Id
                                  </ControlLabel>
                                  <FormControl
                                    type="text"
                                    value={this.state.bid}
                                    placeholder="Script Id"
                                    onChange={this.handleChange}
                                    name="bid"
                                  />
                                </FormGroup>
                              </Col>
                              <Col md={3} xs={3}>
                                <FormGroup>
                                  <ControlLabel>
                                    Script Width
                                  </ControlLabel>
                                  <FormControl
                                    type="text"
                                    value={this.state.bwidth}
                                    placeholder="Script Width"
                                    onChange={this.handleChange}
                                    name="bwidth"
                                  />
                                </FormGroup>
                              </Col>
                              <Col md={3} xs={3}>
                                <FormGroup>
                                  <ControlLabel>
                                    Script Height
                                  </ControlLabel>
                                  <FormControl
                                    type="text"
                                    value={this.state.bheight}
                                    placeholder="Script Height"
                                    onChange={this.handleChange}
                                    name="bheight"
                                  />
                                </FormGroup>
                              </Col>
                            </Row>
                          </React.Fragment>
                          )
                        }
                        
                        <FormGroup controlId="formDescription">
                          <ControlLabel>Description</ControlLabel>
                          <FormControl
                            componentClass="textarea"
                            value={this.state.description}
                            name="description"
                            placeholder="Description"
                            onChange={this.handleChange}
                            style={{ borderColor: validation.description.isInvalid ? 'red' : '' }}
                          />
                        </FormGroup>
                        
                        <FormGroup controlId="formheader">
                          <ControlLabel>Header</ControlLabel>
                          <FormControl
                            componentClass="select"
                            name="header"
                            onChange={this.handleChange}
                            value={this.state.header}
                          >
                            <option value="1">Enabled</option>
                            <option value="0">Disabled</option>
                          </FormControl>
                        </FormGroup>

                        <FormGroup controlId="formmenu">
                          <ControlLabel>Menu</ControlLabel>
                          <FormControl
                            componentClass="select"
                            name="menu"
                            onChange={this.handleChange}
                            value={this.state.menu}
                          >
                            <option value="1">Enabled</option>
                            <option value="0">Disabled</option>
                          </FormControl>
                        </FormGroup>

                        <FormGroup controlId="formfooter">
                          <ControlLabel>Footer</ControlLabel>
                          <FormControl
                            componentClass="select"
                            name="footer"
                            onChange={this.handleChange}
                            value={this.state.footer}
                          >
                            <option value="1">Enabled</option>
                            <option value="0">Disabled</option>
                          </FormControl>
                        </FormGroup>

                        <FormGroup controlId="formhomepage">
                          <ControlLabel>Set as Home Page</ControlLabel>
                          <FormControl
                            componentClass="select"
                            name="homepage"
                            onChange={this.handleChange}
                            value={this.state.homepage}
                          >
                            <option value="1">Yes</option>
                            <option value="0">No</option>
                          </FormControl>
                        </FormGroup>
                      </Col>
                    </Row>

                    <Row>
                      <Col md={10} xs={10} mdOffset={2}>
                        <Button
                          bsStyle="info"
                          type="submit" 
                          disabled={this.props.loading}
                        >
                          Save
                        </Button>
                        <Button
                          bsStyle="default"
                          onClick={() => this.context.router.history.push(`/list`)}
                        >
                          Cancel
                        </Button>
                      </Col>
                    </Row>
                    <br />
                    <Row>
                      <Col md={12} xs={12}>
                        <Table striped bordered condensed hover>
                          <thead>
                            <tr>
                              <th>#</th>
                              <th>Short Code</th>
                              <th>Detail</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>{x++}</td>
                              <td>{'<!--STARTDEAL-->'}</td>
                              <td>Start Deal Row</td>
                            </tr>
                            <tr>
                              <td>{x++}</td>
                              <td>{'<!--ENDDEAL-->'}</td>
                              <td>End Deal Row</td>
                            </tr>
                            <tr>
                              <td>{x++}</td>
                              <td>{'${featuretitle}'}</td>
                              <td>Link in title</td>
                            </tr>
                            <tr>
                              <td>{x++}</td>
                              <td>{'${offerimage}'}</td>
                              <td>Offer Image</td>
                            </tr>
                            <tr>
                              <td>{x++}</td>
                              <td>{'${productURL}'}</td>
                              <td>URL of product</td>
                            </tr>
                            <tr>
                              <td>{x++}</td>
                              <td>{'${mainDealText}'}</td>
                              <td>Main Deal Text</td>
                            </tr>
                            <tr>
                              <td>{x++}</td>
                              <td>{'${offerPrice}'}</td>
                              <td>Offer Price</td>
                            </tr>
                            <tr>
                              <td>{x++}</td>
                              <td>{'${siteDomain}'}</td>
                              <td>Site Domain</td>
                            </tr>
                            <tr>
                              <td>{x++}</td>
                              <td>{'${siteName}'}</td>
                              <td>Site Name</td>
                            </tr>
                            <tr>
                              <td>{x++}</td>
                              <td>{'${siteLogo}'}</td>
                              <td>Site Logo</td>
                            </tr>
                            <tr>
                              <td>{x++}</td>
                              <td>{'${dealImage}'}</td>
                              <td>Deal Image</td>
                            </tr>
                            <tr>
                              <td>{x++}</td>
                              <td>{'${dealText}'}</td>
                              <td>Deal Text</td>
                            </tr>
                            <tr>
                              <td>{x++}</td>
                              <td>{'${offerDesc}'}</td>
                              <td>Deal Description</td>
                            </tr>
                            <tr>
                              <td>{x++}</td>
                              <td>{'${highlights}'}</td>
                              <td>Deal High Lights</td>
                            </tr>
                            <tr>
                              <td>{x++}</td>
                              <td>{'${offervalue}'}</td>
                              <td>Deal Retail Price</td>
                            </tr>
                            <tr>
                              <td>{x++}</td>
                              <td>{'${offersaving}'}</td>
                              <td>Deal saving percentage</td>
                            </tr>
                            <tr>
                              <td>{x++}</td>
                              <td>{'${savingamount}'}</td>
                              <td>Deal saving amount</td>
                            </tr>
                            <tr>
                              <td>{x++}</td>
                              <td>{'${merchantName}'}</td>
                              <td>Merchant Name</td>
                            </tr>
                            <tr>
                              <td>{x++}</td>
                              <td>{'${currency}'}</td>
                              <td>Currency sign</td>
                            </tr>
                          </tbody>
                        </Table>
                      </Col>
                    </Row>
                  </form>
                </Row>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

};

const mapStateToProps = (state, ownProps) => {
  return {
    catList: state.categoryReducer.catData, 
    customdata: state.designCenterReducer.customdata,
    error: state.designCenterReducer.error,
    alertType: state.alertsReducer.alertType,
    message: state.alertsReducer.message,
    loading: state.designCenterReducer.loading,
  };
};

export default compose(withRouter, connect(mapStateToProps,{getAllCategory, CustomPageCreate}))(CustomPageAdd);


// WEBPACK FOOTER //
// ./src/app/views/admin/designCenter/CustomPageAdd.js